/**************
 * Product thumbnail hover image
*/

document.addEventListener('DOMContentLoaded', () => {
	const productEls = document.querySelectorAll('.product')

	if (!productEls) return

	productEls.forEach(productEl => {
		const imageEl = productEl.querySelector('img.attachment-woocommerce_thumbnail')
		const hoverImageEl = productEl.querySelector('img.attachment-woocommerce_thumbnail-hover')

		if (!imageEl || !hoverImageEl) return

		productEl.addEventListener('mouseover', () => {
			hoverImageEl.style.display = 'block'
			imageEl.style.display = 'none'
		})

		productEl.addEventListener('mouseleave', () => {
			hoverImageEl.style.display = 'none'
			imageEl.style.display = 'block'
		})
	})
})
